import React, { useEffect, useRef, useState } from 'react';
import WhoDunIt2026 from '../../classes/WhoDunIt2026';
import { getWhodunit2026Fact } from '../../data/whodunit2026Facts';
import { useWhodunit2026State } from '../../hooks/useWhodunit2026State';
import './PuzzleFact.css';

const DISSOLVE_DURATION_MS = 450;

const PuzzleFact = ({ factId }) => {
  const fact = getWhodunit2026Fact(factId);
  const { isEnabled, progress } = useWhodunit2026State();
  const [isDissolving, setIsDissolving] = useState(false);
  const timerRef = useRef(null);
  const isRevealed = progress.revealedFactIds.includes(factId);

  useEffect(() => () => {
    if (timerRef.current !== null) {
      clearTimeout(timerRef.current);
    }
  }, []);

  if (!isEnabled) {
    return <span>{fact.trueText}</span>;
  }

  const handleActivate = () => {
    if (timerRef.current !== null) {
      return;
    }

    if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) {
      WhoDunIt2026.toggleFact(factId);
      return;
    }

    setIsDissolving(true);
    timerRef.current = setTimeout(() => {
      WhoDunIt2026.toggleFact(factId);
      setIsDissolving(false);
      timerRef.current = null;
    }, DISSOLVE_DURATION_MS);
  };

  return (
    <button
      type="button"
      className={`puzzle-fact${isDissolving ? ' puzzle-fact--dissolving' : ''}${isRevealed ? ' puzzle-fact--revealed' : ''}`}
      onClick={handleActivate}
      aria-pressed={isRevealed}
    >
      <span className="puzzle-fact__content">
        {isRevealed ? fact.clue : fact.puzzleText}
      </span>
    </button>
  );
};

export default PuzzleFact;
